import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import Index from "./pages/Index";
import MorningNote from "./pages/MorningNote";
import NightNote from "./pages/NightNote";
import DailyQuote from "./pages/DailyQuote";
import BuyCoffee from "./pages/BuyCoffee";
import LifeGoals from "./pages/LifeGoals";
import DailyJournal from "./pages/DailyJournal";
import Breathe from "./pages/Breathe";
import SleepSounds from "./pages/SleepSounds";
import Profile from "./pages/Profile";
import { NIP19Page } from "./pages/NIP19Page";
import NotFound from "./pages/NotFound";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/morning" element={<MorningNote />} />
        <Route path="/night" element={<NightNote />} />
        <Route path="/quote" element={<DailyQuote />} />
        <Route path="/coffee" element={<BuyCoffee />} />
        <Route path="/goals" element={<LifeGoals />} />
        <Route path="/journal" element={<DailyJournal />} />
        <Route path="/breathe" element={<Breathe />} />
        <Route path="/sounds" element={<SleepSounds />} />
        <Route path="/profile" element={<Profile />} />
        {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
        <Route path="/:nip19" element={<NIP19Page />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;